import { render } from "./TheCustomerActivityPage.vue?vue&type=template&id=a4e38866"
import script from "./TheCustomerActivityPage.vue?vue&type=script&lang=js"
export * from "./TheCustomerActivityPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__